// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__w1Xu3","name":"ConsentHeader_name__1BDHZ","birthday":"ConsentHeader_birthday__30kZV","skeleton":"ConsentHeader_skeleton__30Rqp"};